import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placeholder-aside',
  templateUrl: './placeholder-aside.component.html',
  styleUrls: ['./placeholder-aside.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceholderAsideComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
